const data = {
  cameras: [],
  selectedTids: []
}

const cameraMenuInArea = (state = data, action) => {
  switch (action.type) {
    case "SET_CAMERA_MENU_IN_AREA":
      return { ...state, cameras: action.val }
    case "SET_TIDS_MENU_IN_AREA":
      return { ...state, selectedTids: action.val }
    default:
      return state
  }
}

export default cameraMenuInArea
